<template>
	<div class="chat-game-role">
		<div class="chat-game-role-search">
			<input type="datetime-local" v-model="requestParam.start_time">
			<input type="datetime-local" v-model="requestParam.end_time">
			<input type="text" v-model="requestParam.keywords" placeholder="游戏名">
			<span @click="search">搜索</span>
			<span class="chat-game-role-back"  @click="bindUser">绑定</span>
		</div>
		<div class="chat-game-role-box">
			<div class="chat-game-role-wrap">
				<table class="layui-table">
				  <thead>
				    <tr>
						<th width="50">平台</th>
						<th>用户ID</th>
						<th>游戏</th>
						<th>区服</th>
						<th>角色名</th>
						<th>角色ID</th>
						<th width="30">等级</th>
						<th>上次登录时间</th>
						<th>上次下线时间</th>
						<th width="30">状态</th>
						<th width="30">操作</th>
				    </tr> 
				  </thead>
				  <tbody v-if="userList.length > 0">
				    <tr v-for="(user,index) in userList">
				      <td>{{user.platform}}</td>
				      <td>{{user.u_id}}</td>
					  <td>{{user.game_name}}</td>
					  <td>{{user.area_name}}</td>
					  <td>{{user.role_name}}</td>
					  <td>{{user.role_id}}</td>
					  <td>{{user.level}}</td>
					  <td>{{user.login_time}}</td>
					  <td>{{user.outline_time}}</td>
					  <td>{{user.online_status}}</td>
					  <td class="chat-game-role-unset" @click="unsetUser(user.id)">解绑</td>
				    </tr>
				  </tbody>
				  <tbody v-else>
					  <tr>
						  <td colspan="11" style="text-align: center;">{{errorMsg}}</td>
					  </tr>
				  </tbody>
				</table>
			</div>
		</div>
		<div class="chat-game-role-page">
			<page-component
				:dataApi="dataApi" 
				:requestParams="requestParam" 
				@page-call="pageCall($event)" 
				key="chat-game-role-page"
				ref="ChatGameRolePage">
			</page-component>
		</div>
	</div>
</template>

<script>
	import PageComponent from '../../../components/PageComponent.vue'
	import {getRoleList,deleteUser} from '../../../network/game/game.js'
	
	export default{
		name:"ChatGameRole",
		props:{
			chatUser:{
				type: Object,
				default: function(){
					return {}
				}
			}
		},
		components:{
			PageComponent
		},
		data(){
			return {
				userList: [],
				dataApi: getRoleList,
				requestParam:{
					start_time:'',
					end_time:'',
					prePage: 10,
					fans_id:0,
					keywords: ''
				},
				errorMsg: '数据请求中...'
			}
		},
		methods:{
			// 分页数据回调
			pageCall(data){
				this.userList = data
				if(data.length === 0){
					this.errorMsg = '暂无角色数据'
				}
			},
			
			// 搜索
			search(){
				this.$refs.ChatGameRolePage.initPage()
			},
			
			// 绑定数据
			bindUser(){
				this.$emit('game-user-call','user')
			},
			
			// 解绑用户-通过角色解绑
			unsetUser(u_id){
				let _this = this
				CHAT_LAYER.confirm('确定解绑当前角色对应的用户吗？', {
					title: '解绑提示',
					btn: ['确定', '取消'] //可以无限个按钮
				}, function(index2, layero){
					CHAT_LAYER.close(index2)
					let param = {
						u_id: u_id
					}
					deleteUser(param,data=>{
						if(data === false){
							CHAT_LAYER.msg('操作失败',{icon: 2})
						}else{
							CHAT_LAYER.msg('操作成功',{icon: 1})
							_this.$refs.ChatGameRolePage.initPage()
							_this.userList = []
							_this.errorMsg = '数据请求中...'
						}
					})
				}, function(index2){
					//按钮【按钮二】的回调
				});
			}
		},
		created() {
			this.requestParam.fans_id = this.chatUser.fans_id
		}
	}
</script>

<style>
.chat-game-role{
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background-color: #FFFFFF;
		z-index: 12;
	}
	.chat-game-role-search{
		height: 28px;
		padding: 10px 0;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.chat-game-role-search input{
		height: 26px;
		line-height: 26px;
		width: 170px;
		border: 1px solid #CCCCCC;
		padding: 0 5px;
		border-radius: 2px;
		color: #666666;
		margin-right: 3px;
	}
	.chat-game-role-search span{
		display: inline-block;
		line-height: 28px;
		padding: 0 10px;
		background-color: #009688;
		color: #FFFFFF;
		border-radius: 2px;
		cursor: pointer;
		margin-right: 3px;
		user-select: none;
	}
	.chat-game-role-back{
		background-color: #00aaff !important;
	}
	.chat-game-role-box{
		position: absolute;
		top: 48px;
		left: 0;
		right: 0;
		bottom: 60px;
		overflow: hidden;
	}
	.chat-game-role-box .chat-game-role-wrap{
		position: relative;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.chat-game-role-wrap>table{
		margin: 0;
		word-break: break-all;
	}
	.chat-game-role-wrap button{
		padding: 0 10px;
		font-size: 12px;
		line-height: 22px;
		background-color: #378996;
		color: #FFFFFF;
		border-radius: 2px;
		cursor: pointer;
		margin-right: 3px;
	}
	.chat-game-role-wrap span{
		font-size: 12px;
	}
	.chat-game-role-page{
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 26px;
		padding: 17px 0;
	}
	.chat-game-role-unset{
		color: red;
		cursor: pointer;
		user-select: none;
	}
</style>
